// src/constants/routes.js
export const ROUTES = {
  LOGIN: '/login',
  ACCEPT_INVITATION: '/accept-invitation',

  // Medical center selection (landing after login)
  MEDICAL_CENTERS: '/medical_centers',

  // Dynamic, RESTful, per-medical-center routes
  MEDICAL_CENTER: (mcId = ':medicalCenterId') => `/medical_centers/${mcId}`,
  PATIENTS: (mcId = ':medicalCenterId') => `/medical_centers/${mcId}/patients`,
  ENROLLMENTS: (mcId = ':medicalCenterId') => `/medical_centers/${mcId}/enrollments`,
  CALL_SESSIONS: (mcId = ':medicalCenterId') => `/medical_centers/${mcId}/call-sessions`,
  USERS: (mcId = ':medicalCenterId') => `/medical_centers/${mcId}/users`,
  ANALYTICS: (mcId = ':medicalCenterId') => `/medical_centers/${mcId}/analytics`,
};

// Patterns used for guards/navigation; keep the param placeholder for matching
export const PROTECTED_ROUTES = [
  ROUTES.MEDICAL_CENTERS,
  ROUTES.MEDICAL_CENTER(),
  ROUTES.PATIENTS(),
  ROUTES.ENROLLMENTS(),
  ROUTES.CALL_SESSIONS(),
  ROUTES.USERS(),
  ROUTES.ANALYTICS(),
];